import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { CyKLProvider } from "@/contexts/CyKLContext";
import { ExperienceProvider } from "@/contexts/ExperienceContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import { Toaster } from "@/components/ui/sonner";

// Lazy load embed components for code splitting
const EmbedTicker = lazy(() => import("@/pages/embed/EmbedTicker"));
const EmbedDial = lazy(() => import("@/pages/embed/EmbedDial"));
const EmbedNotifications = lazy(() => import("@/pages/embed/EmbedNotifications"));

// Simple loading fallback for embeds
const EmbedLoading = () => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    minHeight: '100px',
    background: '#0A0A0F',
    color: '#D4AF37',
    fontFamily: 'Inter, sans-serif',
    fontSize: '12px'
  }}>
    Loading...
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <ThemeProvider>
          <ExperienceProvider>
            <AuthProvider>
              <CyKLProvider>
                <Routes>
                  {/* Embed routes - minimal wrappers for iframe embedding */}
                  <Route path="/embed/ticker" element={
                    <Suspense fallback={<EmbedLoading />}>
                      <EmbedTicker />
                    </Suspense>
                  } />
                  <Route path="/embed/dial" element={
                    <Suspense fallback={<EmbedLoading />}>
                      <EmbedDial />
                    </Suspense>
                  } />
                  <Route path="/embed/notifications" element={
                    <Suspense fallback={<EmbedLoading />}>
                      <EmbedNotifications />
                    </Suspense>
                  } />
                  {/* Main app route */}
                  <Route path="/*" element={<App />} />
                </Routes>
                <Toaster />
              </CyKLProvider>
            </AuthProvider>
          </ExperienceProvider>
        </ThemeProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
